import gql from 'graphql-tag';

export const CREATE_VALUATION_LEAD_MUTATION = gql`
    mutation CreateValuationLead($lead: ValuationLeadInput!) {
        createValuationLead(lead: $lead) {
            uniqueLeadIdentifier
        }
    }
`;
